export default "__VITE_ASSET__DXj3YPLb__"